export const STORAGE_PREFIX = "speedway:tutorial";

export const INTRO_STORAGE_PREFIX = `${STORAGE_PREFIX}:intro`;
export const STATUS_STORAGE_PREFIX = `${STORAGE_PREFIX}:status`;
export const TUTORIAL_LOCK_KEY = `${STORAGE_PREFIX}:lock`;

export function resolveUserId(user) {
  if (!user) return null;
  return user.id || user._id || user.uuid || user.email || null;
}

export function getStatusStorageKey(user) {
  const userId = resolveUserId(user);
  if (!userId) return null;
  return `${STATUS_STORAGE_PREFIX}:${userId}`;
}

export function getIntroStorageKey(user) {
  const userId = resolveUserId(user);
  if (!userId) return null;
  return `${INTRO_STORAGE_PREFIX}:${userId}`;
}

export function readIntroCompleted(storageKey) {
  if (!storageKey || typeof window === "undefined") return false;
  try {
    return localStorage.getItem(storageKey) === "done";
  } catch (err) {
    return false;
  }
}

export function writeIntroCompleted(storageKey) {
  if (!storageKey || typeof window === "undefined") return;
  try {
    localStorage.setItem(storageKey, "done");
    const statusKey = storageKey.startsWith(`${INTRO_STORAGE_PREFIX}:`)
      ? storageKey.replace(`${INTRO_STORAGE_PREFIX}:`, `${STATUS_STORAGE_PREFIX}:`)
      : null;
    if (statusKey && statusKey !== storageKey) {
      const current = readTutorialStatus(statusKey);
      if (!current.introCompleted) {
        writeTutorialStatus(statusKey, {
          ...current,
          introCompleted: true,
        });
      }
    }
  } catch (err) {
    // ignore write failures (Safari private mode, etc.)
  }
}


export function clearIntroCompleted(storageKey) {
  if (!storageKey || typeof window === "undefined") return;
  try {
    localStorage.removeItem(storageKey);
  } catch (err) {
    // ignore read/write issues (Safari private mode, etc.)
  }
}

export function readTutorialStatus(storageKey) {
  if (!storageKey || typeof window === "undefined") {
    return { introCompleted: false, pages: {} };
  }
  try {
    let raw = localStorage.getItem(storageKey);
    if (!raw) {
      const legacyKey = storageKey.startsWith(`${STATUS_STORAGE_PREFIX}:`)
        ? storageKey.replace(`${STATUS_STORAGE_PREFIX}:`, `${STORAGE_PREFIX}:`)
        : null;
      if (legacyKey && legacyKey !== storageKey) {
        raw = localStorage.getItem(legacyKey);
      }
    }
    if (!raw) {
      return { introCompleted: false, pages: {} };
    }
    const parsed = JSON.parse(raw);
    return {
      introCompleted: Boolean(parsed?.introCompleted),
      pages: parsed?.pages || {},
    };
  } catch (err) {
    return { introCompleted: false, pages: {} };
  }
}

export function writeTutorialStatus(storageKey, status) {
  if (!storageKey || typeof window === "undefined") return;
  try {
    const value = JSON.stringify(status);
    localStorage.setItem(storageKey, value);
    const legacyKey = storageKey.startsWith(`${STATUS_STORAGE_PREFIX}:`)
      ? storageKey.replace(`${STATUS_STORAGE_PREFIX}:`, `${STORAGE_PREFIX}:`)
      : null;
    if (legacyKey && legacyKey !== storageKey) {
      localStorage.setItem(legacyKey, value);
    }
  } catch (err) {
    // ignore persistence issues
  }
}

export function setTutorialLock(pageName) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(TUTORIAL_LOCK_KEY, pageName || "active");
  } catch (err) {
    // ignore
  }
}

export function clearTutorialLock(pageName) {
  if (typeof window === "undefined") return;
  try {
    const current = localStorage.getItem(TUTORIAL_LOCK_KEY);
    if (!current) return;
    if (!pageName || current === pageName) {
      localStorage.removeItem(TUTORIAL_LOCK_KEY);
    }
  } catch (err) {
    // ignore
  }
}

export function purgeGuestTutorialStorage() {
  if (typeof window === "undefined") return;
  try {
    const guestKeys = [
      `${INTRO_STORAGE_PREFIX}:guest`,
      `${STATUS_STORAGE_PREFIX}:guest`,
      `${STORAGE_PREFIX}:guest`,
    ];
    guestKeys.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch (err) {
        // ignore
      }
    });
  } catch (err) {
    // ignore
  }
}

export default {
  STORAGE_PREFIX,
  INTRO_STORAGE_PREFIX,
  STATUS_STORAGE_PREFIX,
  TUTORIAL_LOCK_KEY,
  resolveUserId,
  getStatusStorageKey,
  getIntroStorageKey,
  readIntroCompleted,
  writeIntroCompleted,
  clearIntroCompleted,
  readTutorialStatus,
  writeTutorialStatus,
  setTutorialLock,
  clearTutorialLock,
  purgeGuestTutorialStorage,
};